"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.schema = void 0;
exports.schema = { "title": "Options", "$schema": "http://json-schema.org/draft-07/schema#", "properties": { "mood": { "title": "Mood", "type": "array", "items": { "type": "string", "enum": ["happy", "sad", "surprised"] } } }, "additionalProperties": false };
